var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showClearCompletedButton)?_c('button',{on:{"click":_vm.clearCompleted}},[_vm._v("Clear Completed")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }